import React, { useEffect, useState } from 'react';
import { StyledSectionHeader, StyledListContainer, StyledListSection } from "../../utils/common-styles";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { ArticleItemDetail } from "../../components/Articles/ArticleItemDetail";
import { useHttp } from "../../hooks/use-http";
import { ArticleItemSideBar } from "../../components/Sidebar/Articles/ArticleItemSideBar";
import { LoadingArticleItem } from "../../components/Extra/Loading/LoadingArticleItem";
import { Helmet } from "react-helmet";
import { UrlFixer } from "../../utils/utils";

export const ArticleDetailPage = (props) => {

    const { id, slug } = useParams();

    const [article, setArticle] = useState({});
    const [otherArticles, setOtherArticles] = useState([]);

    const { isLoading, error, sendRequest: getContent } = useHttp();

    useEffect(() => {

        const parseContent = (data) => {
            let article = data?.payload?.article;
            let otherArticles = data?.payload?.other;
            setArticle((prevState) => {
                return { ...prevState, ...article };
            });

            setOtherArticles((prevState) => {
                return otherArticles;
            });
        }

        let url = `/articles/item/${id}/detail`;
        getContent({ url }, parseContent);
    }, [id, slug, getContent]);

    return (
        <>
            <Helmet>
                <title>{article?.title ? `${article.title} - Friends of Queen's Wood` : 'Friends of Queen\'s Wood'}</title>
                <meta name="description" content={article?.intro ? `The Friends of Queen's Wood: ${article.intro}` : 'We are a group of volunteers that help to look after the wood'} />
                <meta property="og:type" content="article" />
                <meta property="og:title" content={article?.title || 'Friends of Queen\'s Wood'} />
                <meta property="og:description" content={article?.intro ? `The Friends of Queen's Wood: ` + article.intro : 'We are a group of volunteers that help to look after the wood'} />
                <meta property="og:url" content={`${window.location.origin}/articles/${id}/${slug}`} />
                <meta property="og:image" content={article?.image_details?.variations?.detail_hero || UrlFixer('/assets/og-large-profile.jpg')} />
                <meta name="twitter:title" content={article?.title || 'Friends of Queen\'s Wood'} />
                <meta name="twitter:description" content={article?.intro ? `The Friends of Queen's Wood: ` + article.intro : 'We are a group of volunteers that help to look after the wood'} />
                <meta name="twitter:image" content={article?.image_details?.variations?.detail_hero || UrlFixer('/assets/og-large-profile.jpg')} />
            </Helmet>
            <StyledSectionHeader>
                <div className="container">
                    <h1 className="section-title">About The Wood</h1>
                </div>
            </StyledSectionHeader>
            <StyledListSection>
                <StyledListContainer>
                    <Row>
                        <Col xs={12} md={9}>
                            <p style={{ marginTop: "25px" }}>&nbsp;</p>
                            {isLoading && <LoadingArticleItem />}
                            {!isLoading && <ArticleItemDetail post={article} />}
                            {error && <p style={{ color: "red" }}>An error has occurred. Please try again later.</p>}
                        </Col>
                        <Col xs={12} md={3}>
                            {!isLoading && <ArticleItemSideBar post={article} other={otherArticles} />}
                        </Col>
                    </Row>
                </StyledListContainer>
            </StyledListSection>
        </>
    )
};
